export default __webpack_public_path__ + "static/media/110_mobile.0f871907.jpg";